import { FC, useContext, useState } from 'react';
import { useLocation } from 'react-router';

import { StylesheetContext } from '../../contexts/StylesheetContext';
import StepsService from '../../services/StepsService';
import { PreHeader } from '../PreHeader/PreHeader';
import Steps from '../Steps/Steps';
import { StickyWrapper } from './StickyWrapper';

interface HeaderProps {
  hideStepper?: boolean;
}

const Header: FC<HeaderProps> = ({ hideStepper }) => {
  const { stylesheet } = useContext(StylesheetContext);
  const { pathname } = useLocation();
  const [isSticky, setIsSticky] = useState(false);

  return (
    <StickyWrapper isSticky={isSticky} setIsSticky={setIsSticky}>
      <PreHeader settings={stylesheet.settings} />
      {!hideStepper && StepsService.showSteps(pathname) && <Steps /> }
    </StickyWrapper>
  );
};

export default Header;
